import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formArrayFilterPipe',
    standalone: true,
})
export class FormArrayFilterPipePipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;

        searchText = searchText.toLowerCase();

        return items.filter((it) => {
            return it.value.translateName.toString().toLowerCase().includes(searchText) || it.value.name.toString().toLowerCase().includes(searchText);
        });
    }
}
